import { createContext, useContext } from 'react';

import type { ContentHeaderContextValue } from './types';

export const ContentHeaderContext = createContext<
  ContentHeaderContextValue | undefined
>(undefined);

export function useContentHeaderContext(
  componentName: string
): ContentHeaderContextValue {
  const context = useContext(ContentHeaderContext);
  if (context === undefined) {
    throw new Error(`${componentName} must be used within a ContentHeader`);
  }
  return context;
}
